// extracted by mini-css-extract-plugin
export default {"segmentHolder":"styles_segmentHolder__PDnPE","grid":"styles_grid__gwXcI","flex":"styles_flex__vWLr6","drawer":"styles_drawer__u49Vg"};